import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React from "react";

const DeclineAppointmentModal = ({
  isOpen,
  onClose,
  setSelectedReason,
  selectedReason,
  otherReason,
  setOtherReason,
  handleAction,
  declineFormLoading,
}) => {
  const declineTerms = [
    "Date/Time does not work",
    "Location is too far",
    "Feet condition requires more than one appointment",
    "Feet or patient condition is too complex",
    "Other",
  ];

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-xl bg-white shadow-xl transition-all">
              <div className="bg-[#21140E0F] relative px-6 py-4">
                {/* Header */}
                <div className="border-b">
                  <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-[#1e3a8a]">
                      Decline Appointment
                    </h3>
                    <button
                      onClick={onClose}
                      className="text-gray-400 hover:text-gray-600 text-2xl"
                    >
                      &times;
                    </button>
                  </div>
                  <p className="text-[#8B8D98] text-sm mt-1">
                    Are you sure want to decline this appointment?
                  </p>
                </div>

                {/* Radio Options */}
                <div className="py-4 space-y-3">
                  {declineTerms.map((option) => (
                    <label
                      key={option}
                      className="flex items-center gap-2 text-gray-700 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="rejectReason"
                        value={option}
                        checked={selectedReason === option}
                        onChange={() => setSelectedReason(option)}
                        className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                      />
                      {option}
                    </label>
                  ))}

                  {/* Message Input */}
                  {selectedReason === "Other" && (
                    <textarea
                      className="w-full mt-2 p-2 border rounded-md text-gray-700 focus:ring focus:ring-blue-200"
                      rows="3"
                      placeholder="Enter Message Here..."
                      value={otherReason}
                      onChange={(e) => setOtherReason(e.target.value)}
                    />
                  )}
                </div>

                {/* Action Buttons */}
                <div className="py-4 gap-3 flex justify-between border-t">
                  <button
                    onClick={onClose}
                    className="w-full px-4 py-2 border border-red-500 text-red-500 rounded-lg hover:bg-red-500 hover:text-white transition"
                  >
                    Cancel
                  </button>
                  <button
                    className=" w-full px-4 py-2 bg-[#1e3a8a] text-white rounded-lg hover:bg-blue-900 transition"
                    onClick={() => handleAction("Reject")}
                    disabled={declineFormLoading}
                  >
                    {declineFormLoading ? "loading..." : "Decline"}
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DeclineAppointmentModal;
